import React from 'react';
import { useNotificationJobs } from '../../contexts/NotificationJobsContext';

function jobTitle(job: { metadata?: Record<string, unknown>; type?: string; campaign_name?: string | null }) {
  if (job.type === 'employee_bulk_upload') {
    return 'CSV bulk upload';
  }
  const label = typeof job.metadata?.label === 'string' ? job.metadata.label : null;
  const base = label || job.type || 'Notifications';
  const cn = job.campaign_name?.trim();
  return cn ? `${base} — ${cn}` : base;
}

function jobStatusLine(
  job: { metadata?: Record<string, unknown>; status?: string; total?: number; processed?: number; emailed?: number; onboarded?: number; failed?: number },
  pending: boolean,
): string {
  const total = Number(job.total ?? 0);
  const processed = Number(job.processed ?? 0);
  const emailed = Number(job.emailed ?? 0);
  const onboarded = Number(job.onboarded ?? 0);
  const failed = Number(job.failed ?? 0);
  const hierarchy =
    job.metadata?.hierarchy && typeof job.metadata.hierarchy === 'object'
      ? (job.metadata.hierarchy as { managersAssigned?: number; managersPromoted?: number })
      : null;

  if (pending) {
    return `Processing… ${total ? `${processed}/${total}` : 'starting'}`;
  }

  let line = `Done — onboarded ${onboarded}, emailed ${emailed}, failed ${failed}`;
  if (hierarchy?.managersAssigned != null && hierarchy.managersAssigned > 0) {
    line += `, managers assigned ${hierarchy.managersAssigned}`;
  }
  return line;
}

export default function NotificationJobsBanner() {
  const ctx = useNotificationJobs();
  const jobs = ctx?.jobs ?? [];

  if (!ctx?.organisationId || jobs.length === 0) {
    return null;
  }

  return (
    <div className="mb-4 space-y-2" aria-live="polite">
      {jobs.map((job) => {
        const pending = job.status === 'pending' || job.status === 'processing';

        return (
          <div
            key={job.id}
            className="rounded-lg border px-4 py-3 text-sm"
            style={{
              borderColor: 'var(--e2s-border)',
              background: 'var(--e2s-panel)',
              color: 'var(--e2s-text)',
            }}
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="font-semibold">{jobTitle(job)}</span>
              <span style={{ color: 'var(--e2s-muted)' }}>{jobStatusLine(job, pending)}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
